<template>
  <div class="declaracao">
    <table style="width: 100%; margin-top: 10px;">
      <tr>
        <td colspan="3">
          <table style="width: 100%;">
            <tr>
              <td colspan="3" class="noPad">
                <table style="width: 100%;">
                  <tr>
                    <td class="headerText" height="40">
                      <strong>DECLARAÇÃO DE CONTEÚDO E TERMO DE RESPONSABILIDADE</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px">
          <table style="width: 100%; border: 1px solid #c1c1c1">
            <tr class="border" style="height: 40px;">
              <td style="width: 50%; vertical-align: bottom;">
                Remetente: <span>{{ order.from.name }}</span>
              </td>
              <td style="border-left: 1px solid #c1c1c1; vertical-align: bottom;">
                CPF/CNPJ: <span>{{ order.from.company_document || order.from.document || '' }}</span>
              </td>
            </tr>

            <tr style="height: 25px">
              <td style="vertical-align: bottom;">
                Endereço: <span>{{ order.from.address }}, {{ order.from.location_number }}. <template v-if="order.from.complement">{{ order.from.complement }}.</template> <template v-if="order.from.district">Bairro {{ order.from.district }}</template></span>
              </td>
              <td style="border-left: 1px solid #c1c1c1; vertical-align: bottom;">
                Cidade: <span>{{ order.from.city }}</span>
              </td>
            </tr>
            <tr style="height: 25px">
              <td style="vertical-align: bottom;">
                CEP: <span>{{ order.from.postal_code | postal_code }}</span>
              </td>
              <td style="border-left: 1px solid #c1c1c1; vertical-align: bottom;">
                UF: <span>{{ order.from.state_abbr }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border-left: 1px solid #c1c1c1; border-right: 1px solid #c1c1c1">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>DESTINATÁRIO</strong>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data" style="padding: 0 4px;">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border: 1px solid #c1c1c1">
            <tr style="height: 25px">
              <td colspan="3" style="vertical-align: bottom;">
                Nome: <span>{{ order.to.name }}</span>
              </td>
            </tr>
            <tr style="height: 25px">
              <td colspan="3" style="vertical-align: bottom;">
                CPF/CNPJ: <span>{{ order.to.company_document || order.to.document || '' }}</span>
              </td>
            </tr>
            <tr style="height: 25px">
              <td colspan="3" style="vertical-align: bottom;">
                Endereço: <span>{{ order.to.address }}, {{ order.to.location_number }}. <template v-if="order.to.complement">{{ order.to.complement }}.</template> <template v-if="order.to.district">Bairro {{ order.to.district }}</template></span>
              </td>
            </tr>
            <tr style="height: 25px">
              <td style="width: 33%; vertical-align: bottom;">
                CEP: <span>{{ order.to.postal_code | postal_code }}</span>
              </td>
              <td style="width: 33%; vertical-align: bottom;">
                Cidade: <span>{{ order.to.city }}</span>
              </td>
              <td style="vertical-align: bottom;">
                UF: <span>{{ order.to.state_abbr }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border-left: 1px solid #c1c1c1; border-right: 1px solid #c1c1c1">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>DESCRIÇÃO DE CONTEÚDO</strong>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border: 1px solid #c1c1c1">
            <tr class="border declaracao-center">
              <td style="width: 20%;"><strong>Quantidade</strong></td>
              <td style="border-left: 1px solid #c1c1c1;"><strong>Descrição</strong></td>
              <td style="width: 20%; border-left: 1px solid #c1c1c1;"><strong>Valor (R$)</strong></td>
            </tr>

            <tr class="border declaration-items" v-for="product in order.products" :key="product.id">
              <td style="width: 20%;">{{ product.quantity }}</td>
              <td style="border-left: 1px solid #c1c1c1;">{{ product.name }}</td>
              <td style="width: 20%; border-left: 1px solid #c1c1c1;">{{ (product.unitary_value * product.quantity) | currency }}</td>
            </tr>

            <template v-if="order.products.length < 10">
              <tr class="border" v-for="n in (10 - order.products.length)" :key="n">
                <td style="width: 20%;">&nbsp;</td>
                <td style="border-left: 1px solid #c1c1c1;">&nbsp;</td>
                <td style="width: 20%; border-left: 1px solid #c1c1c1;">&nbsp;</td>
              </tr>
            </template>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border-left: 1px solid #c1c1c1; border-right: 1px solid #c1c1c1">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>DAS RESPONSABILIDADES</strong>
              </td>
            </tr>
            <tr style="font-size: 10pt;">
              <td colspan="2">
                <p style="text-align: justify;">Constitui crime contra a ordem tributária, suprimir ou reduzir tributos, ou contribuição social ou qualquer acessório; quando omitir informação ou prestar declaração falsa às autoridades fazendárias, deixar de fornecer, quando obrigatório, nota fiscal ou documento equivalente, relativo a venda de mercadoria ou prestação de serviços, efetivamente realizada, ou fornece-la em desacordo com a legislação. Pena - reclusão de 2 (dois) a 5 (cinco) anos, e multa.</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border-left: 1px solid #c1c1c1; border-right: 1px solid #c1c1c1">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>DAS CONSIDERAÇÕES (LEI COMPLEMENTAR No 87/96 ART. 4o)</strong>
              </td>
            </tr>
            <tr style="font-size: 10pt;">
              <td colspan="2">
                <p style="text-align: justify;">É considerado contribuinte do ICMS qualquer pessoa, física ou jurídica, que realize, com habitualidade ou em volume que caracterize intuito comercial, operações de circulação de mercadoria ou prestações de serviços de transporte interestadual e intermunicipal e de comunicação, ainda que as operações e as prestações se iniciem no exterior.</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border: 1px solid #c1c1c1; background: #e6e6e6;">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>DECLARAÇÃO</strong>
              </td>
            </tr>
            <tr style="font-size: 9pt;">
              <td colspan="2">
                <p style="text-align: justify;">DECLARO PARA OS DEVIDOS FINS DE DIREITO NÃO SER PESSOA JURIDICA OU PESSOA FISICA QUE REALIZA COM FREQUENCIA OU HABITUALIDADE, OU EM VOLUME QUE CARACTERIZE INTUITO COMERCIAL, OPERAÇÕES DE CIRCULAÇÃO DE MERCADORIA, AINDA QUE ESTAS TENHAM SE INICIADO NO EXTERIOR E QUE O CONTEUDO DECLARADO NÃO É COMPOSTO POR DROGAS, JOIAS, CARGA PERIGOSA, CORRESPONDENCIAS, DINHEIRO EM ESPECIE, MATERIAIS PERECIVEIS, OU QUE CONFIGURE CRIME PREVISTO PELO CODIGO PENAL, CRIME AMBIENTAL PREVISTO NA LEI 9.605 DE 12/02/1998, BEM COMO, A LEI 7.679 DE 23/11/1998. E NÃO ESTANDO SUJEITO À TRIBUTAÇÃO, DECLARO SER O ÚNICO RESPONSAVEL POR EVENTUAIS PENALIDADES OU DANOS DECORRETES DE INFORMAÇÕES INVERIDICAS AQUI PRESTADAS, ISENTANDO DE QUALQUER RESPONSABILIDADE A J&T EXPRESS.</p>
              </td>
            </tr>
            <tr style="font-size: 9pt;">
              <td colspan="2" style="padding-top: 15px; width: 35em;">
                <p class="txtData">LOCAL <span>{{ order.from.city }}</span>, <span>{{ moment(order.generated_at).format('DD') }}</span> DE <span>{{ moment(order.generated_at).format('MMMM') }}</span> DE <span>{{ moment(order.generated_at).format('YYYY') }}</span></p>
              </td>
            </tr>
            <tr style="font-size: 8pt;">
              <td style="width: 50%; text-align: center">
                <p style="padding: 15px 10px 10px;">________________________________________________</p>
                <p>ASSINATURA DO DECLARANTE/REMETENTE</p>
              </td>
              <td><!-- --></td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding: 0 4px;">
          <table style="width: 100%; border-left: 1px solid #c1c1c1; border-right: 1px solid #c1c1c1">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>SENDO O DECLARANTE E/OU REMETENTE O ÚNICO RESPONSAVEL PELAS INFORMAÇÕES AQUI PRESTADAS</strong>
              </td>
            </tr>
          </table>
        </td>
      </tr>

    </table>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    methods: {
      moment
    },

    computed: {
      totals: function () {
        let price = 0;
        let quantity = 0;
        this.order.products.forEach((e) => {
          price += e.quantity * e.unitary_value;
          quantity += e.quantity;
        });

        return {
          'price': price,
          'quantity': quantity
        };
      }
    },

    filters: {
      postal_code(value) {
        return String(value).padStart(8, '0').replace(/(\d{5})(\d{3})$/, '$1-$2');
      },
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      upper(text) {
        return String(text || '').toUpperCase();
      }
    },

    created() {
      moment.locale('pt_br');
    },
  }
</script>

<style lang="stylus" scoped>
body
  -webkit-print-color-adjust exact
  print-color-adjust exact
td
  padding 4px
  &.noPad
    padding 0
.titleLine
  text-align center
  font-size 12px
  td
    padding 0 4px
  p
    background #e6e6e6
    padding 4px 0
.border
  border 1px solid #c1c1c1
  &.declaration-items
    word-break break-word
.headerText
  vertical-align middle
  font-size 15pt
  strong
    display block
    text-align center
.topText
  vertical-align top
  font-size 6pt
.bottomText
  vertical-align bottom
  font-size 6pt
  text-align center
.exclusivos
  background #c7c7c7
  text-align center
  font-size 8pt
.declaracao
  color #000
  font-size 12pt
  font-family Arial, sans-serif
  .declaracao-header
    font-size 15pt
    text-align center
    vertical-align middle
  .txtData
    span
      display inline-block
      border-bottom 1px solid #000
      padding 0 20px
  .declaracao-data
    font-size 10pt
    strong
    span
      font-size 9pt
    tr
      td
        padding 4px
  .declaracao-data-header
    background #e6e6e6
    strong
      display block
      text-align center
      letter-spacing 1px
      padding 5px 0
  .declaracao-center
    strong
      display block
      text-align center
  strong
    font-weight bold

@media print
  .declaracao
    padding 5mm !important
    .declaracao-header
      font-size 11pt
      text-align center
      vertical-align middle
</style>
